import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import {
  fetchSalesOdersByDate, voidSalesOrder, fetchSalesOrders, fetchSalesOrderDetail,
  selectSalesOrder, resetCurrentSalesOrder, setSalesOrdersFilter, setSalesOrdersPaginationFilter,
  setValue, loadsPost, printShippingList, removeSalesOrderPDF, printSalesOrder,
  printPickingList, printPickingListAFG, printPackingList, orderToQuote, quoteToOrder,
  printSalesOrderLabel, printSalesOrderLabelBOL, printSalesOrderLabelDSQ,
  printSalesOrderLabelBatch, createMobileTask, updateShippingWeight, updateShippingWeightSplit,
  emailSO, fetchShippingWeightTracking, fetchJmlTracking, reshipOrder, setQuoteOrder,
  updateVoidNote, chowbusImport, submitBolImage, printBolById, printBolWithoutLog,
  printBolByFba, printBolLabel, fetchBolAddress, jmlPrintLabel, setDavisPO,
  printSalesOrderLabelUSPride, reprintSalesOrderLabelUSPride, setSOToPending,
  setSOToQuote, selectTeapplixShipping, selectTeapplixShipping2, printTeapplixLabel,
  deleteTeapplixShipping, uploadSOFile, teapplixResyncWithPONum, rollBackWithSOIds, stuffResyncWithPONum, resetLocation,
  fetchMultiSOLines, duplicateSOAPI, fetchSalesCustomerDetail, setQuoteOrderForEsc,
  acknowledgeApi, mobileSoDealApi, fetchSalesOrderPDFSuccess, fetchSalesOrderPDFFetch,
  createPickingList, mobileSoDealQuote, mobileSoSetToDoOrOpen, abcffSync, uploadSOWalmartFile, sendSOWalmartFile,
  printPackingSalesOrder, handleSyncToMES
} from '../../actions/sales_actions';
import { 
  fetchSalesOrdersByFilter, 
  searchInvoicesByInvoiceNo, 
  searchInvoicesByTrackingNo,
  updatePrepayStatus,
 } from '../../actions/salesOrderList_actions';
import { setDefaultDays, setDefaultOfForm, emailPOPost } from '../../actions/purchaseOrders_actions';
import { fetchProductSuggestions } from '../../actions/autoSuggest_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import { fetchCustomers, fetchActiveCustomers } from '../../actions/customers_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchAllRoutes2 } from '../../actions/dispatch_actions';

import SalesOrders from '../../components/Sales/salesOrders';

const salesOrders = reduxForm({
  form: 'salesOrders',
  destroyOnUnmount: false,
})(SalesOrders);

const selector = formValueSelector('salesOrders');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const DispatchDays = selector(state, 'DispatchDays');
  const DispatchDateGT = selector(state, 'DispatchDateGT');
  const DispatchDateLT = selector(state, 'DispatchDateLT');
  const Status = selector(state, 'Status');
  const Seller = selector(state, 'Seller');
  const store_name = selector(state, 'store_name');
  const Picker = selector(state, 'Picker');
  const ProductNum = selector(state, 'ProductNum');
  return {
    Days,
    FromDate,
    ToDate,
    DispatchDays,
    DispatchDateGT,
    DispatchDateLT,
    Status,
    Seller,
    store_name,
    Picker,
    ProductNum,
    currentSalesOrder: state.salesOrders.currentSalesOrder,
    salesOrders: state.salesOrders.all,
    isLoading: state.salesOrders.isLoading,
    error: state.salesOrders.error,
    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.salesOrders.detailIsLoading,
    salesOrderError: state.salesOrders.detailError,
    salesOrdersFilter: state.salesOrders.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,

    allroutes: state.dispatch.allroutes,
    allroutesIsLoading: state.dispatch.allroutesIsLoading,
    allroutesError: state.dispatch.allroutesError,
    totalPages: state.salesOrders.totalPages,
    totalRows: state.salesOrders.totalRows,
    currentPage: state.salesOrders.currentPage,
    msoTotalPages: state.salesOrders.msoTotalPages,

    requestingShippingList: state.salesOrders.requestingShippingList,
    shippingListPDF: state.salesOrders.shippingListPDF,

    requestingPickingList: state.salesOrders.requestingPickingList,
    pickingListPDF: state.salesOrders.pickingListPDF,

    requestingPackingList: state.salesOrders.requestingPackingList,
    packingListPDF: state.salesOrders.packingListPDF,

    requestingSalesOrderPDF: state.salesOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.salesOrders.salesOrderPDF,

    requestingBolIdPDF: state.salesOrders.requestingBolIdPDF,
    bolIdPDF: state.salesOrders.bolIdPDF,
    requestingBolWithoutLogPDF: state.salesOrders.requestingBolWithoutLogPDF,
    bolWithoutLogPDF: state.salesOrders.bolWithoutLogPDF,
    requestingBolLabel: state.salesOrders.requestingBolLabel,
    bolLabel: state.salesOrders.bolLabel,
    requestingBolFbaPDF: state.salesOrders.requestingBolFbaPDF,
    bolFbaPDF: state.salesOrders.bolFbaPDF,
    bolAddress: state.salesOrders.bolAddress,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,

    quoteLoading: state.salesOrders.quoteLoading,

    customers: state.customers.all,
    warehouses: state.warehouses.all,
    selectedWarehouse: state.header.selectedWarehouse,
    selectedCompany: state.header.selectedCompany,
    salesShippingCustomerDetails: state.salesOrders.salesShippingCustomerDetails,
  };
}

export default connect(mapStateToProps, {
  fetchMultiSOLines,
  setDefaultDays,
  fetchSalesOdersByDate,
  voidSalesOrder,
  fetchSalesOrders,
  fetchSalesOrderDetail,
  selectSalesOrder,
  resetCurrentSalesOrder,
  loadsPost,
  setSalesOrdersFilter,
  setSalesOrdersPaginationFilter,
  setValue,
  fetchBaseUsers,
  fetchAllRoutes2,
  setDefaultOfForm,
  fetchSalesOrdersByFilter,
  printShippingList,
  removeSalesOrderPDF,
  printSalesOrder,
  printPickingList,
  printPickingListAFG,
  printPackingList,
  fetchProductSuggestions,
  checkPassword,
  clearCheckPassword,
  orderToQuote,
  quoteToOrder,
  jmlPrintLabel,
  printSalesOrderLabel,
  printSalesOrderLabelBOL,
  printSalesOrderLabelDSQ,
  printSalesOrderLabelBatch,
  createMobileTask,
  emailSO,
  emailPOPost,
  updateShippingWeight,
  updateShippingWeightSplit,
  fetchShippingWeightTracking,
  fetchJmlTracking,
  searchInvoicesByInvoiceNo,
  searchInvoicesByTrackingNo,
  reshipOrder,
  setQuoteOrder,
  setQuoteOrderForEsc,
  updateVoidNote,
  chowbusImport,
  submitBolImage,
  printBolById,
  printBolWithoutLog,
  printBolLabel,
  printBolByFba,
  fetchBolAddress,
  fetchCustomers,
  fetchWarehouses,
  setDavisPO,
  printSalesOrderLabelUSPride,
  reprintSalesOrderLabelUSPride,
  setSOToPending,
  setSOToQuote,
  selectTeapplixShipping,
  selectTeapplixShipping2,
  printTeapplixLabel,
  deleteTeapplixShipping,
  uploadSOFile,
  teapplixResyncWithPONum,
  rollBackWithSOIds,
  stuffResyncWithPONum,
  resetLocation,
  duplicateSOAPI,
  fetchSalesCustomerDetail,
  acknowledgeApi,
  mobileSoDealApi,
  fetchSalesOrderPDFSuccess,
  fetchSalesOrderPDFFetch,
  createPickingList,
  mobileSoDealQuote,
  mobileSoSetToDoOrOpen,
  abcffSync,
  fetchActiveCustomers,
  uploadSOWalmartFile,
  sendSOWalmartFile,
  printPackingSalesOrder,
  updatePrepayStatus,
  handleSyncToMES
})(salesOrders);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesOrders.jsx